export default __webpack_public_path__ + "static/media/ic-cloud_big.274b187e.svg";